import React from 'react';
import { useSelector } from 'react-redux';
import iconsList from '../../../ui/icons/iconsList';
import FinalWhatToExpectItem from '../FinalWhatToExpect/FinalWhatToExpectItem/FinalWhatToExpectItem';
import classes from '../FinalWhatToExpect/FinalWhatToExpect.module.css';

const FinalWhatToExpectCharedi = () => {

  const { contentInfoJson } = useSelector((state) => state.contest);
  const { texts } = useSelector((state) => state.translate);
  const finalInfo = contentInfoJson?.final?.finalInfo;

  return (
    <div className={classes.card}>
      <p className={classes.title}>{texts?.finalSection_liveTitleCharedi}</p>
      <div className={classes.itemsRow}>
        <FinalWhatToExpectItem icon={iconsList.finalMinutes} value={finalInfo?.minutes ?? '—'} label={texts?.finalSection_minutesLabel} />
        <span className={classes.iconDivider} />
        <FinalWhatToExpectItem icon={iconsList.events} value={finalInfo?.events ?? '—'} label={texts?.finalSection_eventsLabel} />
        <span className={classes.iconDivider} />
        <FinalWhatToExpectItem icon={iconsList.everyone} value={finalInfo?.whoInvited ?? '—'} label={texts?.finalSection_whoInvitedLabel} />
        <span className={classes.iconDivider} />
        <FinalWhatToExpectItem icon={iconsList.camera} value={"Live"} label={texts?.finalSection_liveLabelCharedi} />
      </div>
    </div>
  );
};

export default FinalWhatToExpectCharedi;
